import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import * as driverApis from "../../utilities/apis/driver"
import Layout from "../../components/Layout"

const Drivers = () => {
  const navigate = useNavigate()
  const { user, token, permissions } = useSelector(state => state.user)
  const [drivers, setDrivers] = useState([])
  const [status, setStatus] = useState("")

  const handleNew = () => {
    navigate("/dashboard/driver")
  }

  const handleEdit = (id) => {
    navigate(`/dashboard/driver?id=${id}`)
  }

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete?")) return

      const response = await driverApis.deleteDriver(token, id)
      if (!response.status) throw new Error(response.message)

      setDrivers((previous) => {
        const drivers = previous.filter(x => x.id !== id)
        return [...drivers]
      })
    } catch (error) {
    }
  }

  const getDrivers = async () => {
    try {
      const query = new URLSearchParams()
      if (status) query.append("active", status === "active")
      const response = await driverApis.getDrivers(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setDrivers(response.drivers)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getDrivers()
  }, [status])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Riders</p>
            <div className="d-flex gap-2">
              {permissions["READ_DRIVERS"] && <button className="btn btn-secondary rounded-4">Export</button>}
              {permissions["CREATE_DRIVER"] && <Link to="/dashboard/driver" className="btn btn-theme rounded-4">New</Link>}
            </div>
          </div>

          <div class="border rounded-4 mb-3">
            <div className="p-3 border-bottom rounded-top-4 bg-secondary">
              <div className="d-flex gap-2">
                <button type="button" className={`btn btn-sm ${!status && "bg-body-secondary"} rounded-3`} onClick={() => setStatus("")}>All</button>
                <button type="button" className={`btn btn-sm ${status === "active" && "bg-body-secondary"} rounded-3`} onClick={() => setStatus("active")}>Active</button>
                <button type="button" className={`btn btn-sm ${status === "inactive" && "bg-body-secondary"} rounded-3`} onClick={() => setStatus("inactive")}>Inactive</button>
              </div>
            </div>
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "40%" }}>Name</th>
                  <th scope="col" style={{ width: "30%" }}>Mobile #</th>
                  <th scope="col" style={{ width: "20%" }} className="text-center">Commission</th>
                  <th scope="col" style={{ width: "10%" }} className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {drivers.map((row) => (
                  <tr key={row.id.toString()}>
                    <td className="align-middle">{row.name}</td>
                    <td className="align-middle">{row.mobile}</td>
                    <td className="align-middle text-center">{row.commission && `Rs. ${row.commission.toFixed(2)}`}</td>
                    <td className="align-middle">
                      <div className="d-flex gap-2 justify-content-center">
                        {permissions["UPDATE_DRIVER"] && <Link to={`/dashboard/driver?id=${row.id}`}><i className="far fa-edit"></i></Link>}
                        {permissions["DELETE_DRIVER"] && <a className="text-danger" onClick={() => handleDelete(row.id)}><i className="far fa-trash-alt"></i></a>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default Drivers
